// Context used by SignedInUserInfo and UserSignInPage to enable local sign-in/out and display of user info for the
import React from "react";
export const LocalSignInContext = React.createContext(
// undefined! as the default value allows us to specify a default where we have no reasonable default, and
// not require checks for undefined anytime we access LocalSignInContext, which will always be initialized
// by the component providing this context.
undefined);
